export const environment = {
  production: false,
  url: "https://espace-client.obexto.fr/api/v2/",
  paApiBaseUrl: 'https://pa-dev.obexto.net/netcore/pa',
  PAAccess: { "Authorization": "sSHQbbwTVfg9NGYovepQFTsRzImkYERScLwJOMDgDIcq0lFrXKZcTtWud6PHhJQm" }
};
